import style from "./style.module.css";
import lectureinfo from "../../../assets/modalIcons/lectureinfo.svg";
import cross from "../../../assets/modalIcons/cross.svg";
import deleteicon from "../../../assets/modalIcons/delete.svg";
import save from "../../../assets/modalIcons/save.svg";
import excel from "../../../assets/modalIcons/excel.svg";
import { useContext, useState } from "react";
import StoreContext from "../../../context/store";
import Multiselect from 'multiselect-react-dropdown';

import { deleteTeacher, editTeacher } from "../../../api/general";
import {
  successMessage,
  errorMessage,
  warningMessage,
} from "../../../helpers/toast";

const EditTeacherModal = ({ teacherId, branches }) => {
  const { setEditTeacherClick, teacher } = useContext(StoreContext);
  
  const [nameSurname, setNamesurname] = useState(teacher.nameSurname);
  const [password, setPassword] = useState(null);
  const [unvan, setUnvan] = useState(teacher.unvan);
  const [brans, setBrans] = useState(teacher.branches);
  const [phone, setPhone] = useState(teacher.phone);
  const [email, setEmail] = useState(teacher.email);
  
  const deleteTeacherMethod = async () => {
    const response = await deleteTeacher(teacherId);
    if (response.error) {
      console.log("Öğretmen silme başarısız");
      console.log(response.error, "response.erro");
      errorMessage(response.error.response.data.error);
      errorMessage("Öğretmen silinemedi");
    } else {
      console.log("Öğretmen silme başarılı");
      successMessage("Öğretmen silindi");
      setEditTeacherClick(false);

      setTimeout(function () {
        window.location.reload();
      }, 2500);
    }
  };

  const editTeacherMethod = async () => {
    if (
      nameSurname === "" ||
      unvan === "" ||
      brans === "" ||
      phone === "" ||
      email === ""
    ) {
      warningMessage("Lütfen boş alan bırakmayınız");

      return;
    }

    const response = await editTeacher(
      nameSurname,
      password,
      unvan,
      brans,
      phone,
      email,
      teacherId
    );
    if (response.error) {
      console.log("Öğretmen güncelleme başarısız");
      console.log(response.error, "response.erro");
      errorMessage(response.error.response.data.error);
      errorMessage("Öğretmen güncellenemedi");
    } else {
      console.log("Öğretmen güncelleme başarılı");
      successMessage("Öğretmen güncellendi");
      setEditTeacherClick(false);

      setTimeout(function () {
        window.location.reload();
      }, 2500);
    }
  };

  return (
    <div className={style.modal}>
      <div className={style.modalbox}>
        <div className={style.uppertabs}>
          <div className={style.tableftside}>
            <div className={style.tab1}>
              <button className={style.tabicon1}>
                <img alt="" src={lectureinfo}></img>
              </button>
              <div className={style.tabtext1}>Öğretmen Bilgileri</div>
            </div>
          </div>
          <div className={style.tabrightside}>
            <div className={style.tab}>
              <button
                className={style.tabicon}
                onClick={() => {
                  setEditTeacherClick(false);
                }}
              >
                <img alt="" src={cross}></img>
              </button>
              <div className={style.tabtext}>Kapat</div>
            </div>
          </div>
        </div>
        <div className={style.inputs}>
          <div className={style.input}>
            <div className={style.inputtitle}>Öğretmen Adı Soyadı</div>
            <input
              className={style.inputtext}
              value={nameSurname}
              onChange={(e) => setNamesurname(e.target.value)}
            ></input>
          </div>
          <div className={style.input}>
            <div className={style.inputtitle}>E-mail</div>
            <input
              className={style.inputtext}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            ></input>
          </div>
          <div className={style.input}>
            <div className={style.inputtitle}>Ünvanı</div>
            <input
              className={style.inputtext}
              value={unvan}
              onChange={(e) => setUnvan(e.target.value)}
            ></input>
          </div>
          <div className={style.input}>
            <div className={style.inputtitle}>Branşı</div>
            <div className={style.inputtext}>
              <Multiselect
                displayValue="value"
                onSelect={setBrans}
                onRemove={setBrans}
                options={branches}
                selectedValues={brans}
                placeholder=""
                style={{
                  chips: {
                    background: '#3733bf',
                    height: "20px"
                  },
                  multiselectContainer: {
                    color: '#3733bf',
                    border: 'none',
                    width: '100%',
                    height: "30px",
                  },
                  searchBox: {
                    border: 'none',
                    width: '100%',
                    height: "30px",
                    padding: "0px 0px 0px 5px",
                  }
                }}
              />
            </div>
          </div>
          <div className={style.input}>
            <div className={style.inputtitle}>Telefon No</div>
            <input
              className={style.inputtext}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            ></input>
          </div>
          <div className={style.input}>
            <div className={style.inputtitle}>Öğretmen Şifresi</div>
            <input
              className={style.inputtext}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            ></input>
          </div>
        </div>
        <div className={style.lowertabs}>
          <div className={style.tableftside}>
            <div className={style.tab1}>
              <button
                className={style.tabicon1}
                onClick={() => {
                  deleteTeacherMethod();
                }}
              >
                <img alt="" src={deleteicon}></img>
              </button>
              <div className={style.tabtext1}>Sil</div>
            </div>
          </div>
          <div className={style.tabrightside}>
            <div className={style.tab}>
              <button
                className={style.tabicon}
                onClick={() => {
                  editTeacherMethod();
                }}
              >
                <img alt="" src={save}></img>
              </button>
              <div className={style.tabtext}>Kaydet</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditTeacherModal;
